import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=7828cd76&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=ts&"
export * from "./Goal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7828cd76",
  null
  
)

export default component.exports